<template>
	<div>
		<p>
			{{
				selectRandom([
					"To increase participant enrolment we",
					"To increase the number of participants, we ",
					"To increase the number of people to participate, we ",
					"Participant enrolment will be increased with "
				])
			}}
			{{
				joinArrayWithAnd(
					formatSelectMulti($tera.project.TrialWizard.recruitment)
				)
			}}.
		</p>
	</div>
</template>

<script>
import OutputMixin from "@/mixins/OutputMixin.js";
export default {
	name: "OutputRecruitment",
	mixins: [OutputMixin]
};
</script>
